import React, { Suspense } from "react";
import { Grid } from "@mui/material";
import { Loader } from "../Loader";
import { useDropdown } from "src/hooks/useDropdown.hook";

const FeedbackConfig = React.lazy(() => import("./FeedbackConfig"));
const SupportConfig = React.lazy(() => import("./SupportConfig"));

const Communicate = ({ values, setFieldValue, advanceSettingValue, containerStyle = { padding: 2 }, ...rest }) => {
  const { data: queues } = useDropdown("queues", advanceSettingValue.advance_settings?.erp_company_id);
  const { data: caseCategories } = useDropdown("case_categories", advanceSettingValue.advance_settings?.erp_company_id);
  // Feedback logic
  const feedbackConfigType = values.communication.feedback_config_type;
  const feedbackEmail = values.communication.feedback_email || "";
  const feedbackCrm = values.communication.feedback_crm_id || "";
  const feedbackCaseCategory =
    values.communication.feedback_case_category_id || "";
  const onFeedbackConfigChange = (e) => setFieldValue("communication.feedback_config_type", e.target.value);
  const onFeedbackEmailChange = (e) => setFieldValue("communication.feedback_email", e.target.value);
  const onFeedbackCrmChange = (e) => setFieldValue("communication.feedback_crm_id", e.target.value);
  const onFeedbackCaseCategoryChange = (e) => setFieldValue("communication.feedback_case_category_id", e.target.value);

  // Support logic
  const supportConfigType = values.communication.support_config_type;
  const supportEmail = values.communication.support_email || "";
  const supportCrm = values.communication.support_crm_id || "";
    const supportCaseCategory =
      values.communication.support_case_category_id || "";
  const onSupportConfigChange = (e) => setFieldValue("communication.support_config_type", e.target.value);
  const onSupportEmailChange = (e) => setFieldValue("communication.support_email", e.target.value);
  const onSupportCrmChange = (e) => setFieldValue("communication.support_crm_id", e.target.value);
  const onSupportCaseCategoryChange = (e) => setFieldValue("communication.support_case_category_id", e.target.value);
  return (
    <Grid container spacing={4} sx={containerStyle}>
      <Suspense fallback={<Loader />}>
        <FeedbackConfig
          feedbackConfigType={feedbackConfigType}
          onFeedbackConfigChange={onFeedbackConfigChange}
          feedbackEmail={feedbackEmail}
          onFeedbackEmailChange={onFeedbackEmailChange}
          feedbackCrm={feedbackCrm}
          onFeedbackCrmChange={onFeedbackCrmChange}
          feedbackCaseCategory={feedbackCaseCategory}
          onFeedbackCaseCategoryChange={onFeedbackCaseCategoryChange}
          queuesList={queues}
          caseCategoriesList={caseCategories}
          {...rest}
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <SupportConfig
          supportConfigType={supportConfigType}
          onSupportConfigChange={onSupportConfigChange}
          supportEmail={supportEmail}
          onSupportEmailChange={onSupportEmailChange}
          supportCrm={supportCrm}
          queuesList={queues}
          supportCaseCategory={supportCaseCategory}
          onSupportCrmChange={onSupportCrmChange}
          caseCategoriesList={caseCategories}
          onSupportCaseCategoryChange={onSupportCaseCategoryChange}
          {...rest}
        />
      </Suspense>
    </Grid>
  );
};

export default Communicate;
